/**
 * Class-Name-Merger — minimal, ohne extra Dependencies.
 *
 * Filtert falsy values (false, null, undefined, "") und joint zu space-separated string.
 * Für Tailwind: einfache Verkettung reicht — kein clsx/tw-merge nötig.
 *
 * @example
 *   cn('px-4', isActive && 'bg-gold', !isActive && 'bg-transparent')
 *   // → "px-4 bg-gold" oder "px-4 bg-transparent"
 */
export function cn(...classes: Array<string | false | null | undefined>): string {
  return classes.filter(Boolean).join(' ');
}
